<template lang="pug">
b-modal#modal-widget-copy(title='widgetをコピーします。')
  .row
    .form-group.col-12
      label widget名
      input(type="text",class="form-control",:value="$store.state.widget.name",@input="updateName($event)")
  template(v-slot:modal-footer)
    b-button(variant="default",@click="copyWidget($event)") 複製する
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    redirect_url: String
  },
  methods: {
    async copyWidget(e){
      e.preventDefault()
      await this.$store.dispatch("widget/copy")
      location.href = this.redirect_url
    },
    updateName(e){
      e.preventDefault()
      this.$store.commit("widget/setName", e.target.value)
    }
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
